// This file is automatically generated. Do not edit it directly.
// import { createClient } from '@supabase/supabase-js';
// import type { Database } from './types';
// import { mockSupabase } from './mockClient';
// Using mock client for offline mode (localStorage)
import { mockSupabase } from './mockClient';
export const supabase = mockSupabase as any;